import supportApiModule from '../supportApi.module';

class SupportConfigApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getCaseListConfig() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/config/cases/list`
        );
    }

    getCaseStatusConfig() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/config/cases/statuses`
        );
    }

    getCaseForm() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/config/cases/form`
        );
    }

    getCaseCommentConfig() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/config/cases/comments`
        );
    }
}

export default supportApiModule.service(
    'supportConfigApiService',
    SupportConfigApiService
);



// WEBPACK FOOTER //
// ./modules/supportApi/config/supportConfigApi.service.js